import { useSelector } from 'react-redux';
import React from 'react';

export const Loading = () => {
  const loading = useSelector((state) => state?.app?.loading);
  if (!loading) return null;
  return (
    <div
      style={{
        position: 'fixed',
        left: 0,
        top: 0,
        zIndex: '100',
        background: 'black',
        opacity: '.4',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100vw',
        height: '100%',
      }}
    >
      <div className='spinner-border text-primary' role='status'>
        <span className='sr-only'>Loading...</span>
      </div>
    </div>
  );
};

export default Loading;
